import { userCloudApiFetch as apiFetch } from './userCloudApi';

export async function addTrackToPlaylist(playlistId, track) {
  const position = track.position || 0;
  const rawId = String(track.id || track.serviceTrackId || '').replace(/^qobuz:track:/, '');
  const isLocal = track.source === 'local_library'
    || rawId.startsWith('local:track:')
    || !!track.file_path;
  const metadata = {
    title: track.title, artistName: track.artistName || track.artist,
    duration: track.duration || 0, coverUrl: track.coverUrl || track.artworkUrl,
    albumTitle: track.albumTitle || track.album,
    albumId: track.albumId || track.album_id || null,
  };
  if (isLocal) {
    metadata.file_path = track.file_path;
    metadata.machine_id = track.machine_id;
    metadata.format = track.format;
    metadata.bit_depth = track.bit_depth;
    metadata.sample_rate = track.sample_rate;
  }
  return apiFetch(`/api/user/playlists/${encodeURIComponent(playlistId)}/tracks`, 'POST', {
    track_id: rawId,
    source: isLocal ? 'local_library' : (track.source || 'qobuz'),
    position,
    metadata,
  });
}
